import store from '@/store';
import { findModule } from '@/stores/appModule';

export const setModule = function set(name) {
  const module = findModule(name);
  store.dispatch('appModules/SETMODULE', module);
};
function buildDateString(daysToGoBack) {
  const d = new Date();
  d.setDate(d.getDate() - daysToGoBack);
  const dd = (`0${d.getDate()}`).slice(-2);
  const mm = (`0${d.getMonth() + 1}`).slice(-2);
  const yyyy = d.getFullYear();
  const date = `${yyyy}-${mm}-${dd}`;
  return date;
}
function ensureArray(prop) {
  return (Array.isArray(prop)) ? prop : Array.of(prop);
}

export default [
  {
    path: '/personId',
    name: 'personId',
    redirect: 'personId/dashboard',
    component: () => import(/* webpackChunkName: "PersonId" */ '@/views/PersonId/PersonIdRouterView.vue'),
    beforeEnter(to, from, next) {
      if (!store.getters.permissions.includes('PRSID:APP:NAV:VIEW')) {
        next({
          name: 'notAuthorized',
        });
      } else {
        setModule('personId');
        if (to.meta.permission && (
          (Array.isArray(to.meta.permission)
            && !store.getters.permissions.some(r => to.meta.permission.indexOf(r) >= 0))
            || (!store.getters.permissions.includes(to.meta.permission))
        )) {
          next({
            name: 'notAuthorized',
          });
        }
        next();
      }
    },
    children: [
      {
        path: 'notAuthorized',
        name: 'pidNotAuthorized',
        component: () => import(/* webpackChunkName: "noAuthorization" */ '@/views/NoAuthorization.vue'),
      },
      {
        path: 'dashboard',
        name: 'pidDashboard',
        meta: { title: 'Person ID: Dashboard' },
        component: () => import(/* webpackChunkName: "pidDashboard" */ '@/views/PersonId/Dashboard/Dashboard.vue'),
      },
      {
        path: 'reports',
        props: true,
        component: () => import(/* webpackChunkName: "reports" */ '@/views/ReportsMyActivity.vue'),
        children: [
          {
            // UserProfile will be rendered inside User's <router-view>
            // when /user/:id/profile is matched
            path: '',
            name: 'reportsmainp',
            props: true,
            component: () => import(/* webpackChunkName: "reports" */ '@/views/Reports.vue'),
            meta: { permission: 'PRSID:REP:VIEW', title: 'Person ID: Reports' },
          },
        ],
      },
      {
        path: 'reportdescriptions',
        props: true,
        component: () => import(/* webpackChunkName: "reports" */ '@/views/ReportDescriptions.vue'),
        children: [
          {
            path: 'aliasidreport',
            name: 'aliasidreport',
            props: true,
            component: () => import(/* webpackChunkName: "reports" */ '@/views/PersonId/Report/PidReport.vue'),
            meta: { permission: 'PRSID:REP:ALIASID' },
            children: [
              {
                path: 'customize',
                name: 'customizeAliasIdReport',
                meta: { permission: 'PRSID:REP:ALIASID', title: 'Person ID: Alias ID Report' },
                components: {
                  customizePanel: () => import(/* webpackChunkName: "reports" */ '@/views/PersonId/Report/AliasIdReport/AliasIdReportForm.vue'),
                  myActivity: () => import(/* webpackChunkName: "reports" */ '@/views/PersonId/Report/PidReportActivity.vue'),
                  quickTips: () => import(/* webpackChunkName: "reports" */ '@/components/QuickTipsAliasIdReport.vue'),
                  resultsPanel: () => import(/* webpackChunkName: "reports" */ '@/views/PersonId/Report/AliasIdReport/AliasIdReportResults.vue'),
                },
              },
            ],
          },
          {
            path: 'canceledrecordreport',
            name: 'canceledRecordReport',
            props: true,
            component: () => import(/* webpackChunkName: "reports" */ '@/views/PersonId/Report/PidReport.vue'),
            meta: { permission: 'PRSID:REP:CANCELED' },
            children: [
              {
                path: 'customize',
                name: 'customizeCanceledRecordReport',
                meta: { permission: 'PRSID:REP:CANCELED', title: 'Person ID: Canceled Record Report' },
                components: {
                  customizePanel: () => import(/* webpackChunkName: "reports" */ '@/views/PersonId/Report/PidReportForm.vue'),
                  myActivity: () => import(/* webpackChunkName: "reports" */ '@/views/PersonId/Report/PidReportActivity.vue'),
                  quickTips: () => import(/* webpackChunkName: "reports" */ '@/components/QuickTipsCanceledRecordReport.vue'),
                  resultsPanel: () => import(/* webpackChunkName: "reports" */ '@/views/PersonId/Report/CanceledRecordReport/CanceledRecordReportResults.vue'),
                },
              },
            ],
          },
          {
            path: 'nearmatchbylocationreport',
            name: 'nearMatchByLocationReport',
            props: true,
            component: () => import(/* webpackChunkName: "reports" */ '@/views/PersonId/Report/PidReport.vue'),
            meta: { permission: 'PRSID:REP:NEARMATCHBYLOC' },
            children: [
              {
                path: 'customize',
                name: 'customizeNearMatchByLocationReport',
                meta: { permission: 'PRSID:REP:NEARMATCHBYLOC', title: 'Person ID: Near Match by Location Report' },
                components: {
                  customizePanel: () => import(/* webpackChunkName: "reports" */ '@/views/PersonId/Report/PidReportForm.vue'),
                  resultsPanel: () => import(/* webpackChunkName: "reports" */ '@/views/PersonId/Report/NearMatchByLocationReport/NearMatchByLocationReportResults.vue'),
                  myActivity: () => import(/* webpackChunkName: "reports" */ '@/views/PersonId/Report/PidReportActivity.vue'),
                  quickTips: () => import(/* webpackChunkName: "reports" */ '@/components/QuickTipsNearMatchByLocation.vue'),
                },
              },
            ],
          },
          {
            path: 'nohistoryreport',
            name: 'noHistoryReport',
            props: true,
            component: () => import(/* webpackChunkName: "reports" */ '@/views/PersonId/Report/PidReport.vue'),
            meta: { permission: 'PRSID:REP:NOHIST' },
            children: [
              {
                path: 'customize',
                name: 'customizeNoHistoryReport',
                meta: { permission: 'PRSID:REP:NOHIST', title: 'Person ID: No History Report' },
                components: {
                  customizePanel: () => import(/* webpackChunkName: "reports" */ '@/views/PersonId/Report/PidReportForm'),
                  myActivity: () => import(/* webpackChunkName: "reports" */ '@/views/PersonId/Report/PidReportActivity.vue'),
                  quickTips: () => import(/* webpackChunkName: "reports" */ '@/components/QuickTipsNoHistory.vue'),
                  resultsPanel: () => import(/* webpackChunkName: "reports" */ '@/views/PersonId/Report/NoHistoryReport/NoHistoryReportResults.vue'),
                },
              },
            ],
          },
          {
            path: 'submissionhistoryreport',
            name: 'submissionhistoryreport',
            props: true,
            component: () => import(/* webpackChunkName: "reports" */ '@/views/PersonId/Report/PidReport.vue'),
            meta: { permission: 'PRSID:REP:SUBMHIST' },
            children: [
              {
                path: 'customize',
                name: 'customizeSubmissionHistoryReport',
                meta: { permission: 'PRSID:REP:SUBMHIST', title: 'Person ID: Submission History Report' },
                components: {
                  customizePanel: () => import(/* webpackChunkName: "reports" */ '@/views/PersonId/Report/PidReportForm.vue'),
                  myActivity: () => import(/* webpackChunkName: "reports" */ '@/views/PersonId/Report/PidReportActivity.vue'),
                  quickTips: () => import(/* webpackChunkName: "reports" */ '@/components/QuickTipsSubmissionHistory.vue'),
                  resultsPanel: () => import(/* webpackChunkName: "reports" */ '@/views/PersonId/Report/SubmissionHistoryReport/SubmissionHistoryReportResults.vue'),
                },
              },
            ],
          },
        ],
      },
      {
        path: 'addPerson',
        name: 'pidAddPerson',
        meta: { permission: 'PRSID:MATCH:OPTIONS:PRSN:ADD', title: 'Person ID: Add a Person' },
        component: () => import(/* webpackChunkName: "pidAddPerson" */ '@/views/PersonId/AddPerson/AddPerson.vue'),
      },
      {
        path: 'matchHistory',
        name: 'pidMatchHistory',
        meta: { permission: 'PRSID:MATCH:HISTORY:VIEW', title: 'Person ID: Match History' },
        component: () => import(/* webpackChunkName: "pidMatchHistory" */ '@/views/PersonId/MatchHistory/MatchHistoryRouterView.vue'),
        children: [
          {
            path: 'batches',
            name: 'pidMatchHistoryBatches',
            meta: { permission: 'PRSID:MATCH:HISTORY:VIEW', title: 'Match History: Batches' },
            components: {
              matchHistoryResults: () => import(/* webpackChunkName: "pidMatchHistoryBatches" */ '@/views/PersonId/MatchHistory/Batches.vue'),
            },
            props: {
              matchHistoryResults: (route) => {
                const {
                  sortField,
                  sortOrder,
                  batchId,
                  page,
                  endDate,
                  startDate,
                  districtCode = [],
                  status = [],
                  schoolCode = [],
                  schoolYear = [],
                } = route.query;

                return {
                  sortField,
                  sortOrder,
                  batchId,
                  endDate,
                  page,
                  startDate,
                  districtCodes: ensureArray(districtCode),
                  status: ensureArray(status),
                  schoolCodes: ensureArray(schoolCode),
                  schoolYear: ensureArray(schoolYear),
                };
              },
            },
            beforeEnter(to, from, next) {
              const route = Object.assign({}, to);
              if (!route.query.schoolYear) {
                route.query.schoolYear = store.state.propertiesModule.properties['RULE-CURRENT_SCHOOL_YEAR'];
                next(route);
              }
              if (
                !route.query.batchId && !route.query.startDate) {
                route.query.startDate = buildDateString(29);
                next(route);
              }
              next();
            },
          },
          {
            path: 'transactions',
            name: 'pidMatchHistoryTransactions',
            meta: { permission: 'PRSID:MATCH:HISTORY:VIEW', title: 'Match History: Transactions' },
            components: {
              matchHistoryResults: () => import(/* webpackChunkName: "pidMatchHistoryTransactions" */ '@/views/PersonId/MatchHistory/Transactions.vue'),
            },
            props: {
              matchHistoryResults: (route) => {
                const {
                  sortField,
                  sortOrder,
                  pidBatchId,
                  pidSubmissionId,
                  endDate,
                  page,
                  pageNum,
                  startDate,
                  districtCode = [],
                  status = [],
                  schoolCode = [],
                  schoolYear = [],
                } = route.query;

                return {
                  sortField,
                  sortOrder,
                  pidBatchId,
                  pidSubmissionId,
                  endDate,
                  page,
                  pageNum,
                  startDate,
                  districtCodes: ensureArray(districtCode),
                  status: ensureArray(status),
                  schoolCodes: ensureArray(schoolCode),
                  schoolYear: ensureArray(schoolYear),
                };
              },
            },
            beforeEnter(to, from, next) {
              const route = Object.assign({}, to);
              if (!route.query.pidSubmissionId
                  && !route.query.pidBatchId
                  && !route.query.startDate) {
                route.query.startDate = buildDateString(29);
                if (!route.query.schoolYear) {
                  route.query.schoolYear = store.state.propertiesModule.properties['RULE-CURRENT_SCHOOL_YEAR'];
                }
                next(route);
              }
              next();
            },
          },
          {
            path: 'rejected',
            name: 'pidMatchHistoryRejected',
            meta: { permission: 'PRSID:MATCH:HISTORY:VIEW', title: 'Match History: Rejected Batches' },
            components: {
              matchHistoryResults: () => import(/* webpackChunkName: "pidMatchHistoryRejected" */ '@/views/PersonId/MatchHistory/Rejected.vue'),
            },
            props: {
              matchHistoryResults: (route) => {
                const {
                  pidBatchId, // Batch ID
                  schoolYear = [], // School Year
                  startDate, // Process Range Start Date
                  endDate, // Process Range End Date
                  // sortField,
                  // sortOrder,
                  page,
                } = route.query;
                return {
                  pidBatchId,
                  schoolYear: ensureArray(schoolYear),
                  startDate,
                  endDate,
                  // sortField,
                  // sortOrder,
                  page,
                };
              },
            },
            beforeEnter(to, from, next) {
              const route = Object.assign({}, to);
              if (!route.query.pidBatchId
                  && !route.query.startDate) {
                route.query.startDate = buildDateString(29);
                if (!route.query.schoolYear) {
                  route.query.schoolYear = store.state.propertiesModule.properties['RULE-CURRENT_SCHOOL_YEAR'];
                }
                next(route);
              }
              next();
            },
          },
        ],
      },
      {
        path: 'matchOptions',
        name: 'matchOptionsPersonId',
        props: true,
        redirect: { name: 'pidMatchOptionsUpload' },
        component: () => import(/* webpackChunkName: "pidMatchOptions" */ '@/views/PersonId/MatchOptions/MatchOptionsRouterView.vue'),
        meta: { permission: 'PRSID:MATCH:OPTIONS:VIEW', title: 'Person ID: Match Options' },
        beforeEnter(to, from, next) {
          if (to.name === 'matchOptionsPersonId') {
            const routes = [
              {
                name: 'pidMatchOptionsUpload',
                permission: 'PRSID:MATCH:OPTIONS:UPLOADFILE',
              },
              // {
              //   name: 'pidMatchOptionsIndividual',
              //   permission: 'PRSID:MATCH:OPTIONS:UPLOADFILE',
              // },
            ];
            const availableRoutes = routes
              .find(route => store.getters.permissions.includes(route.permission));

            if (!availableRoutes) {
              next({ name: 'pidNotAuthorized' });
            }
            next({ name: availableRoutes.name });
          }
          next();
        },
        children: [
          {
            path: 'upload',
            name: 'pidMatchOptionsUpload',
            meta: { permission: 'PRSID:MATCH:OPTIONS:UPLOADFILE', title: 'Person ID: Match Options - Upload File' },
            components: {
              matchOptionsForm: () => import(/* webpackChunkName: "pidMatchOptions" */ '@/views/PersonId/MatchOptions/MatchOptionsUpload.vue'),
              matchOptionsQuickTips: () => import(/* webpackChunkName: "pidMatchOptions" */ '@/components/QuickTipsPersonMatchOptionsUpload.vue'),
            },
          },
          // {
          //   path: 'individual',
          //   name: 'pidMatchOptionsIndividual',
          //   meta: { permission: 'PRSID:MATCH:OPTIONS:INDIVIDUALMATCH' },
          //   components: {
          //     matchOptionsForm: () => import(/* webpackChunkName: "pidMatchOptions" */
          //       '@/views/PersonId/MatchOptions/MatchOptionsIndividual.vue'),
          //   },
          // },
        ],
      },
      {
        path: 'districtInfo/:code',
        name: 'PIDistrictInfo',
        component: () => import(/* webpackChunkName: "districtInfo" */ '@/views/DistrictInfo/DistrictInfoHeader.vue'),
        props: true,
        children: [
          {
            path: 'details',
            name: 'PIDistrictInfoDetails',
            meta: { title: 'District Profile: Details' },
            component: () => import(/* webpackChunkName: "districtInfo" */ '@/views/DistrictInfo/DistrictInfoDetails.vue'),
            props: true,
          },
          {
            path: 'download',
            name: 'PIDistrictInfoDownloadOptions',
            meta: { permission: 'PRSID:DWNLD:DOWNLOAD', title: 'District Profile: Download' },
            component: () => import(/* webpackChunkName: "districtInfo" */ '@/views/DistrictInfo/DistrictInfoDownloadOptions.vue'),
            props: true,
          },
        ],
      },
      {
        path: 'districtInfo/:districtCode/schoolInfo/:schoolCode',
        name: 'PISchoolInfo',
        component: () => import(/* webpackChunkName: "schoolInfo" */ '@/views/SchoolInfo/SchoolInfoHeader.vue'),
        props: true,
        children: [
          {
            path: 'details',
            name: 'PISchoolInfoDetails',
            meta: { title: 'School Profile: Details' },
            component: () => import(/* webpackChunkName: "schoolInfo" */ '@/views/SchoolInfo/SchoolInfoDetails.vue'),
            props: true,
          },
          {
            path: 'download',
            name: 'PISchoolInfoDownloadOptions',
            meta: { permission: 'PRSID:DWNLD:DOWNLOAD', title: 'School Profile: Download' },
            component: () => import(/* webpackChunkName: "schoolInfo" */ '@/views/SchoolInfo/SchoolInfoDownloadOptions.vue'),
            props: true,
          },
        ],
      },
      {
        path: 'batch/:batchId',
        name: 'PIBatchInfoHeader',
        redirect: { name: 'PIBatchInfoDetails' },
        component: () => import(/* webpackChunkName: "BatchInfo" */ '@/views/PersonId/BatchProfile/PersonBatchProfileHeader.vue'),
        props: true,
        children: [
          {
            path: 'details',
            name: 'PIBatchInfoDetails',
            meta: { title: 'Person ID: Batch Profile - Details' },
            component: () => import(/* webpackChunkName: "BatchInfo" */ '@/views/PersonId/BatchProfile/PersonBatchProfileDetails.vue'),
            props: true,
          },
          {
            path: 'download',
            name: 'PIBatchInfoDownload',
            meta: { permission: 'PRSID:DWNLD:DOWNLOAD', title: 'Person ID: Batch Profile - Download' },
            component: () => import(/* webpackChunkName: "BatchInfo" */ '@/views/PersonId/BatchProfile/PersonBatchProfileDownload.vue'),
            props: true,
          },
        ],
      },
      {
        path: 'rejected/:batchId',
        name: 'PIBatchInfoHeader',
        redirect: { name: 'PIRejectedBatchInfoDetails' },
        component: () => import(/* webpackChunkName: "BatchInfo" */ '@/views/PersonId/BatchProfile/PersonBatchProfileHeader.vue'),
        props: true,
        children: [
          {
            path: 'details',
            name: 'PIRejectedBatchInfoDetails',
            meta: { title: 'Person ID: Rejected Batch Profile - Details' },
            component: () => import(/* webpackChunkName: "BatchInfo" */ '@/views/PersonId/BatchProfile/PersonBatchProfileDetails.vue'),
            props: true,
          },
          {
            path: 'download',
            name: 'PIRejectedBatchInfoDownload',
            meta: { permission: 'PRSID:DWNLD:DOWNLOAD', title: 'Person ID: Rejected Batch Profile - Download' },
            component: () => import(/* webpackChunkName: "BatchInfo" */ '@/views/PersonId/BatchProfile/PersonBatchProfileDownload.vue'),
            props: true,
          },
        ],
      },
      {
        path: 'individualMatch/:transactionId',
        name: 'PITransactionInfoHeader',
        redirect: { name: 'PITransactionInfoDetails' },
        component: () => import(/* webpackChunkName: "TransactionInfo" */ '@/views/PersonId/TransactionProfile/PersonTransactionProfileHeader.vue'),
        props: true,
        children: [
          {
            path: 'person',
            name: 'PITransactionInfoPerson',
            component: () => import(/* webpackChunkName: "TransactionInfo" */ '@/views/PersonId/TransactionProfile/PersonTransactionProfilePerson.vue'),
            props: true,
          },
          {
            path: 'details',
            name: 'PITransactionInfoDetails',
            meta: { title: 'Person ID: Transaction Profile - Details' },
            component: () => import(/* webpackChunkName: "TransactionInfo" */ '@/views/PersonId/TransactionProfile/PersonTransactionProfileDetails.vue'),
            props: true,
          },
          {
            path: 'download',
            name: 'PITransactionInfoDownload',
            meta: { permission: 'PRSID:DWNLD:DOWNLOAD', title: 'Person ID: Transaction Profile - Download' },
            component: () => import(/* webpackChunkName: "TransactionInfo" */ '@/views/PersonId/TransactionProfile/PersonTransactionProfileDownload.vue'),
            props: true,
          },
        ],
      },
      {
        path: 'downloadSearchResult',
        name: 'pidSearchDownloadHeader',
        meta: { permission: 'PRSID:DWNLD:DOWNLOAD' },
        component: () => import(/* webpackChunkName: "pidSearchDownload" */ '@/views/PersonId/Search/SearchDownloadHeader.vue'),
        props: true,

        children: [
          {
            path: 'download',
            name: 'PidSearchDownload',
            meta: { permission: 'PRSID:DWNLD:DOWNLOAD', title: 'Person ID: Search Profile - Download' },
            component: () => import(/* webpackChunkName: "TransactionInfo" */ '@/views/PersonId/Search/SearchDownload.vue'),
            props: true,
          },
        ],
      },
      {
        path: 'personProfile/:id',
        component: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfile.vue'),
        props: true,
        meta: { permission: 'PRSID:PRPRF:PROFILE:VIEW' },
        beforeEnter: (to, from, next) => {
          // Only proceed with query modification if 'retired' is not 'true'
          // and avoid recursion if query already matches the intended state
          if (to.query.retired !== 'true' && to.query.retired !== 'false') {
            const newQuery = { ...to.query, retired: 'false' };
            // Check if the query is already set to 'false' to prevent unnecessary redirect
            if (JSON.stringify(newQuery) !== JSON.stringify(to.query)) {
              next({ path: to.path, query: newQuery }); // Re-trigger with the updated query
            } else {
              next(); // Proceed if no change is necessary
            }
          } else {
            next(); // Proceed as usual if 'retired' is 'true' or 'false'
          }
        },
        children: [
          {
            path: 'overview',
            name: 'PidOverview',
            meta: { permission: 'PRSID:PRPRF:PROFILE:VIEW', title: 'Person Profile: Overview' },
            components: {
              personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
              personProfileBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileOverview.vue'),
            },
            props: {
              personProfileBody: true,
            },
          },
          {
            path: 'masterRecord',
            name: 'PidMasterRecord',
            meta: { permission: 'PRSID:PRPRF:PROFILE:VIEW', title: 'Person Profile: Master Record' },
            components: {
              personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
              personProfileBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileMasterRecord.vue'),
            },
            props: {
              personProfileBody: true,
            },
            children: [
              {
                path: 'masterLocationInfoDetails',
                name: 'PidMasterLocationInfoDetails',
                meta: { permission: 'PRSID:PRPRF:PROFILE:VIEW', title: 'Person Profile: Master Location Information' },
                components: {
                  personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
                  personProfileSubBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileMasterLocationInfoDetails.vue'),
                },
                props: {
                  personProfileSubBody: true,
                },
              },
              {
                path: 'addNote',
                name: 'PidAddNote',
                meta: { permission: ['PRSID:PRPRF:NOTES:ADD:GENERAL', 'PRSID:PRPRF:NOTES:ADD:ADMIN'], title: 'Person Profile: Add a Note' },
                components: {
                  personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
                  personProfileSubBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileMasterAddNote.vue'),
                },
                props: {
                  personProfileSubBody: true,
                },
              },
              {
                path: 'addLocation',
                name: 'PidAddLocation',
                meta: { permission: 'PRSID:PRPRF:PROFILE:VIEW', title: 'Person Profile: Add Location' },
                components: {
                  personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
                  personProfileSubBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileMasterAddLocation.vue'),
                },
                props: {
                  personProfileSubBody: true,
                },
              },
            ],
          },
          {
            path: 'historyRecords',
            name: 'PidHistoryRecords',
            meta: { permission: 'PRSID:PRPRF:PROFILE:VIEW', title: 'Person Profile: History Records' },
            components: {
              personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
              personProfileBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHistoryRecords.vue'),
            },
            props: {
              personProfileBody: true,
            },
            children: [
              {
                path: 'historyRecordDetails',
                name: 'PidHistoryRecordDetails',
                meta: { permission: 'PRSID:PRPRF:PROFILE:VIEW', title: 'Person Profile: History Record Details' },
                components: {
                  personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
                  personProfileSubBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHistoryRecordDetails.vue'),
                },
                props: {
                  personProfileSubBody: true,
                },
              },
              {
                path: 'historyLocationInfoDetails',
                name: 'PidHistoryLocationInfoDetails',
                meta: { permission: 'PRSID:PRPRF:PROFILE:VIEW', title: 'Person Profile: Master Location Information' },
                components: {
                  personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
                  personProfileSubBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHistoryLocationInfoDetails.vue'),
                },
                props: {
                  personProfileSubBody: true,
                },
              },
            ],
          },
          {
            path: 'associatedRecords',
            name: 'PidAssociatedRecords',
            meta: { permission: 'PRSID:PRPRF:PROFILE:VIEW', title: 'Person Profile: Associated Records' },
            components: {
              personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
              personProfileBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileAssociatedRecords.vue'),
            },
            props: {
              personProfileBody: true,
            },
            children: [
              {
                path: 'associatedRecordDetails',
                name: 'PidAssociatedRecordDetails',
                meta: { permission: 'PRSID:PRPRF:PROFILE:VIEW', title: 'Person Profile: Associated Record Details' },
                components: {
                  personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
                  personProfileSubBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileAssociatedRecordDetails.vue'),
                },
                props: {
                  personProfileSubBody: true,
                },
              },
              {
                path: 'associatedLocationInfoDetails',
                name: 'PidAssociatedLocationInfoDetails',
                meta: { permission: 'PRSID:PRPRF:PROFILE:VIEW', title: 'Person Profile: Master Location Information' },
                components: {
                  personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
                  personProfileSubBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileAssociatedLocationInfoDetails.vue'),
                },
                props: {
                  personProfileSubBody: true,
                },
              },
            ],
          },
          {
            path: 'directMatch',
            name: 'PidPersonProfileDirectMatch',
            meta: { permission: 'PRSID:PRPRF:PROFILE:VIEW', title: 'Person Profile: DirectMatch' },
            components: {
              personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
              personProfileBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileDirectMatch.vue'),
            },
            props: {
              personProfileBody: route => ({
                id: route.params.id,
                sortField: route.query.sortField,
                sortOrder: route.query.sortOrder,
                personProfileBody: true,
              }),
            },
          },
        ],
      },
      {
        path: 'search',
        name: 'PidSearch',
        component: () => import(/* webpackChunkName: "pidSearch" */ '@/views/PersonId/Search/SearchOptionsRouterView.vue'),
        meta: { permission: 'PRSID:SRCH:OPTIONS:VIEW', title: 'Person ID: Search Options' },
        props: (route) => {
          const {
            sortField,
            sortOrder,
            page,
            id,
            idType,
            sourceCode,
            ethnicityCode = [],
            genderCode = [],
            raceCode = [],
            gradeCode = [],
            districtCode = [],
            schoolCode = [],
          } = route.query;
          return {
            sortField,
            sortOrder,
            page,
            id,
            idType,
            sourceCode,
            ethnicityCodes: ensureArray(ethnicityCode),
            genderCodes: ensureArray(genderCode),
            raceCodes: ensureArray(raceCode),
            gradeCodes: ensureArray(gradeCode),
            districtCodes: ensureArray(districtCode),
            schoolCodes: ensureArray(schoolCode),
          };
        },
        beforeEnter(to, from, next) {
          if (to.name === 'PidSearch') {
            const routes = [
              {
                name: 'PidSearchPerson',
                permission: 'PRSID:SRCH:OPTIONS:PRSN:SRCH',
              },
              {
                name: 'PidSearchId',
                permission: 'PRSID:SRCH:OPTIONS:PRSN:SRCH',
              },
              {
                name: 'PidSearchLocation',
                permission: 'PRSID:SRCH:OPTIONS:LOC:SRCH',
              },
              {
                name: 'PidSearchFile',
                permission: 'PRSID:SRCH:OPTIONS:BATCH:SRCH',
              },
              {
                name: 'PidSearchAdvanced',
                permission: 'PRSID:SRCH:OPTIONS:ADV:SRCH',
              },
            ];
            const availableRoutes = routes
              .find(route => store.getters.permissions.includes(route.permission));

            if (!availableRoutes) {
              next({ name: 'pidNotAuthorized' });
            }
            next({ name: availableRoutes.name });
          }
          next();
        },
        children: [
          {
            path: 'person',
            name: 'PidSearchPerson',
            meta: { permission: 'PRSID:SRCH:OPTIONS:PRSN:SRCH', title: 'Person ID: Search by Person' },
            components: {
              searchOptionsSelection: () => import(/* webpackChunkName: "pidSearch" */ '@/views/PersonId/Search/SearchOptionsByPerson.vue'),
              searchOptionsQuickTips: () => import(/* webpackChunkName: "pidSearch" */ '@/components/QuickTipsSearchPerson.vue'),
            },
          },
          {
            path: 'id',
            name: 'PidSearchId',
            meta: { permission: 'PRSID:SRCH:OPTIONS:PRSN:SRCH', title: 'Person ID: Search by ID' },
            components: {
              searchOptionsSelection: () => import(/* webpackChunkName: "pidSearch" */ '@/views/PersonId/Search/SearchOptionsById.vue'),
              searchOptionsQuickTips: () => import(/* webpackChunkName: "pidSearch" */ '@/components/QuickTipsSearchId.vue'),
            },
          },
          {
            path: 'location',
            name: 'PidSearchLocation',
            meta: { permission: 'PRSID:SRCH:OPTIONS:LOC:SRCH', title: 'Person ID: Search by Location' },
            components: {
              searchOptionsSelection: () => import(/* webpackChunkName: "pidSearch" */ '@/views/PersonId/Search/SearchOptionsByLocation.vue'),
              searchOptionsQuickTips: () => import(/* webpackChunkName: "pidSearch" */ '@/components/QuickTipsSearchLocation.vue'),
            },
          },
          {
            path: 'file',
            name: 'PidSearchFile',
            meta: { permission: 'PRSID:SRCH:OPTIONS:BATCH:SRCH', title: 'Person ID: Search by File' },
            components: {
              searchOptionsSelection: () => import(/* webpackChunkName: "pidSearch" */ '@/views/PersonId/Search/SearchOptionsByFile.vue'),
              searchOptionsQuickTips: () => import(/* webpackChunkName: "pidSearch" */ '@/components/QuickTipsSearchFile.vue'),
            },
          },
          {
            path: 'adv',
            name: 'PidSearchAdvanced',
            meta: { permission: 'PRSID:SRCH:OPTIONS:ADV:SRCH' },
            components: {
              searchOptionsSelection: () => import(/* webpackChunkName: "pidSearch" */ '@/views/PersonId/Search/SearchOptionsAdvanced.vue'),
              searchOptionsQuickTips: () => import(/* webpackChunkName: "pidSearch" */ '@/components/QuickTipsSearchAdvanced.vue'),
            },
          },
        ],
      },
      {
        path: 'search/file/:searchId',
        name: 'PidSearchInfoHeader',
        redirect: { name: 'PidSearchInfoDetails' },
        component: () => import(/* webpackChunkName: "SearchInfo" */ '@/views/PersonId/SearchProfile/PersonSearchProfileHeader.vue'),
        props: true,
        children: [
          {
            path: 'details',
            name: 'PidSearchInfoDetails',
            meta: { title: 'Person ID: Search Profile - Details' },
            component: () => import(/* webpackChunkName: "SearchInfo" */ '@/views/PersonId/SearchProfile/PersonSearchProfileDetails.vue'),
            props: true,
          },
          {
            path: 'download',
            name: 'PidSearchInfoDownload',
            meta: { permission: 'PRSID:DWNLD:DOWNLOAD', title: 'Person ID: Search Profile - Download' },
            component: () => import(/* webpackChunkName: "SearchInfo" */ '@/views/PersonId/SearchProfile/PersonSearchProfileDownload.vue'),
            props: true,
          },
        ],
      },
      {
        path: 'identifierManager',
        name: 'PIIdManager',
        meta: { permission: 'PRSID:IDENT:IDMANAGER:VIEW' },
        redirect: { name: 'PIOverview' },
        component: () => import(/* webpackChunkName: "identifierManager" */ '@/views/IDManager/IdManagerRouterView.vue'),
        props: true,
        beforeEnter(to, from, next) {
          if (to.name === 'PIIdManager') {
            const routes = [
              {
                name: 'PIOverview',
                permission: 'PRSID:IDENT:IDMANAGER:VIEW',
              },
              {
                name: 'PIDuplicateSearch',
                permission: 'PRSID:IDENT:DUPLICATES:VIEW',
              },
              {
                name: 'PIRetireMerge',
                permission: 'PRSID:IDENT:RETIREID',
              },
              {
                name: 'PISharedId',
                permission: 'PRSID:IDENT:SHAREDIDS:VIEW',
              },
              {
                name: 'PISplitId',
                permission: 'PRSID:IDENT:SEPARATEID',
              },
              {
                name: 'PISplitIdDetails',
                permission: 'PRSID:IDENT:SEPARATEID',
              },
            ];
            const availableRoutes = routes
              .find(route => store.getters.permissions.includes(route.permission));

            if (!availableRoutes) {
              next({ name: 'pidNotAuthorized' });
            }
            next({ name: availableRoutes.name });
          }
          next();
        },
        children: [
          {
            path: 'overview',
            name: 'PIOverview',
            meta: { permission: 'PRSID:IDENT:IDMANAGER:VIEW', title: 'ID Manager: Overview' },
            components: {
              idManagerSelection: () => import(/* webpackChunkName: "identifierManager" */ '@/views/IDManager/IdManagerOverview.vue'),
            },
          },
          {
            path: 'duplicateSearch',
            name: 'PIDuplicateSearch',
            meta: { permission: 'PRSID:IDENT:DUPLICATES:VIEW', title: 'ID Manager: Duplicate Search' },
            components: {
              idManagerSelection: () => import(/* webpackChunkName: "identifierManager" */ '@/views/IDManager/IdManagerDuplicateSearch.vue'),
            },
          },
          {
            path: 'retireMergeId',
            name: 'PIRetireMerge',
            meta: { permission: 'PRSID:IDENT:RETIREID', title: 'ID Manager: Retire/Merge ID' },
            components: {
              idManagerSelection: () => import(/* webpackChunkName: "identifierManager" */ '@/views/IDManager/IdManagerRetireMergeId.vue'),
            },
          },
          {
            path: 'retireMergeIdDetails',
            name: 'PIRetireMergeDetails',
            meta: { permission: 'PRSID:IDENT:RETIREID', title: 'ID Manager: Retire/Merge ID Details' },
            components: {
              idManagerSelection: () => import(/* webpackChunkName: "identifierManager" */ '@/views/IDManager/IdManagerRetireMergeIdDetails.vue'),
            },
          },
          {
            path: 'sharedId',
            name: 'PISharedId',
            meta: { permission: 'PRSID:IDENT:SHAREDIDS:VIEW', title: 'ID Manager: Share ID Search' },
            components: {
              idManagerSelection: () => import(/* webpackChunkName: "identifierManager" */ '@/views/IDManager/IdManagerSharedId.vue'),
            },
          },
          {
            path: 'splitId',
            name: 'PISplitId',
            meta: { permission: 'PRSID:IDENT:SEPARATEID', title: 'ID Manager: Split ID' },
            components: {
              idManagerSelection: () => import(/* webpackChunkName: "identifierManager" */ '@/views/IDManager/IdManagerSplitId.vue'),
            },
          },
          {
            path: 'splitIdDetails',
            name: 'PISplitIdDetails',
            meta: { permission: 'PRSID:IDENT:SEPARATEID', title: 'ID Manager: Split ID Details' },
            components: {
              idManagerSelection: () => import(/* webpackChunkName: "identifierManager" */ '@/views/IDManager/IdManagerSplitIdDetails.vue'),
            },
          },
        ],
      },
      {
        path: 'ruleManager',
        name: 'PidRuleManager',
        meta: { permission: 'SYS:SYS:RULEMGR:VIEW' },
        redirect: { name: 'PidRuleManagerPersonId' },
        component: () => import(/* webpackChunkName: "ruleManager" */ '@/views/RuleManager/RuleManagerHeader.vue'),
        props: true,
        children: [
          {
            path: 'personId',
            name: 'PidRuleManagerPersonId',
            meta: { title: 'Rule Manager: Person ID' },
            component: () => import(/* webpackChunkName: "ruleManager" */ '@/views/RuleManager/RuleManagerPersonId.vue'),
            props: true,
          },
          {
            path: 'directMatch',
            name: 'PidRuleManagerDirectMatch',
            meta: { title: 'Rule Manager: DirectMatch' },
            component: () => import(/* webpackChunkName: "ruleManager" */ '@/views/RuleManager/RuleManagerDirectMatch.vue'),
            props: true,
          },
        ],
      },
      {
        path: 'configurationManager',
        name: 'PIConfigurationManager',
        redirect: { name: 'PISystemConfiguration' },
        component: () => import(/* webpackChunkName: "configurationManager" */ '@/views/Configuration/ConfigurationManagerRouterView.vue'),
        meta: { permission: 'SYS:SYS:CONFIGMGR:VIEW' },
        beforeEnter(to, from, next) {
          if (to.name === 'PIConfigurationManager') {
            const routes = [
              {
                name: 'PISystemConfiguration',
                permission: 'SYS:SYS:CONFIGMGR:VIEW',
              },
              {
                name: 'PIPersonIdConfiguration',
                permission: 'SYS:SYS:CONFIGMGR:PRSIDTAB',
              },
              {
                name: 'PIDirectMatchConfiguration',
                permission: 'SYS:SYS:CONFIGMGR:DRMCHTAB',
              },
              {
                name: 'PIDataMartsConfiguration',
                permission: 'SYS:SYS:CONFIGMGR:DATAMARTTAB',
              },
              {
                name: 'PIScheduleConfiguration',
                permission: 'SYS:SYS:CONFIGMGR:SCHEDTAB',
              },
              {
                name: 'PIIntegrationConfiguration',
                permission: 'SYS:SYS:CONFIGMGR:INTEGRATIONTAB',
              },
            ];
            const availableRoutes = routes
              .find(route => store.getters.permissions.includes(route.permission));

            if (!availableRoutes) {
              next({ name: 'PINotAuthorized' });
            }
            next({ name: availableRoutes.name });
          }
          next();
        },
        children: [
          {
            path: 'system',
            name: 'PISystemConfiguration',
            meta: { permission: 'SYS:SYS:CONFIGMGR:VIEW', title: 'Configuration Manager: System' },
            components: {
              configurationManagerSelection: () => import(/* webpackChunkName: "systemConfiguration" */ '@/views/Configuration/ConfigurationSystemRouterView.vue'),
            },
          },
          {
            path: 'personId',
            name: 'PIPersonIdConfiguration',
            meta: { permission: 'SYS:SYS:CONFIGMGR:PRSIDTAB', title: 'Configuration Manager: Person ID' },
            components: {
              configurationManagerSelection: () => import(/* webpackChunkName: "personIdConfiguration" */ '@/views/Configuration/ConfigurationPersonIdRouterView.vue'),
            },
          },
          {
            path: 'directmatch',
            name: 'PIDirectMatchConfiguration',
            meta: { permission: 'SYS:SYS:CONFIGMGR:DRMCHTAB', title: 'Configuration Manager: Directmatch' },
            components: {
              configurationManagerSelection: () => import(/* webpackChunkName: "directMatchConfiguration" */ '@/views/Configuration/ConfigurationDirectMatchRouterView.vue'),
            },
          },
          {
            path: 'datamarts',
            name: 'PIDataMartsConfiguration',
            meta: { permission: 'SYS:SYS:CONFIGMGR:DATAMARTTAB', title: 'Configuration Manager: Data Marts' },
            components: {
              configurationManagerSelection: () => import(/* webpackChunkName: "datamartsConfiguration" */ '@/views/Configuration/ConfigurationDataMartsRouterView.vue'),
            },
          },
          {
            path: 'schedule',
            name: 'PIScheduleConfiguration',
            meta: { permission: 'SYS:SYS:CONFIGMGR:SCHEDTAB', title: 'Configuration Manager: Schedule' },
            components: {
              configurationManagerSelection: () => import(/* webpackChunkName: "scheduleConfiguration" */ '@/views/Configuration/ConfigurationScheduleRouterView.vue'),
            },
          },
          {
            path: 'integration',
            name: 'PIIntegrationConfiguration',
            meta: { permission: 'SYS:SYS:CONFIGMGR:INTEGRATIONTAB', title: 'Configuration Manager: Integration' },
            components: {
              configurationManagerSelection: () => import(/* webpackChunkName: "integrationConfiguration" */ '@/views/Configuration/ConfigurationIntegrationRouterView.vue'),
            },
          },
        ],
      },
      {
        path: 'securityManager',
        name: 'PidSecurityManager',
        meta: { title: 'Security Manager' },
        component: () => import(/* webpackChunkName: "pidSecurityManager" */ '@/views/SecurityManager/SecurityManager.vue'),
        props: (route) => {
          const {
            sortField,
            sortOrder,
            page,
            search,
            isActive,
            role = [],
            districtCode = [],
            schoolCode = [],
            group = [],
            status = [],
          } = route.query;

          return {
            sortField,
            sortOrder,
            page,
            search,
            isActive: Boolean(isActive),
            roleCodes: ensureArray(role),
            districtCodes: ensureArray(districtCode),
            schoolCodes: ensureArray(schoolCode),
            groupCodes: ensureArray(group),
            statuses: ensureArray(status),
          };
        },
      },
      {
        path: 'user/:id',
        name: 'PidUser',
        component: () => import(/* webpackChunkName: "user" */ '@/views/Users/UserProfile.vue'),
        props: true,
        meta: { permission: 'SYS:SEC:USRMGR:VIEW', title: 'Security Manager: User Profile' },
      },
      {
        path: 'addOption',
        name: 'PidAddUser',
        component: () => import(/* webpackChunkName: "user" */ '@/views/Users/AddUser.vue'),
        props: true,
        meta: { permission: 'SYS:SEC:USRMGR:ADD', title: 'Security Manager: Add Options' },
      },
      {
        path: 'roles/:roleId',
        name: 'PidSecurityManagerHeader',
        component: () => import(/* webpackChunkName: "securtiyManager" */ '@/components/SecurityManagerHeader.vue'),
        props: true,
        meta: { permission: 'SYS:SEC:ROLEMGR:VIEW' },
        children: [
          {
            path: 'details',
            name: 'PidSecurityManagerDetails',
            component: () => import(/* webpackChunkName: "securtiyManager" */ '@/views/SecurityManager/SecurityManagerDetails.vue'),
            props: true,
            meta: { permission: 'SYS:SEC:ROLEMGR:VIEW', title: 'Security Manager: Role Profile - Details' },
          },
          {
            path: 'privileges',
            name: 'PidSecurityManagerPrivilege',
            component: () => import(/* webpackChunkName: "securtiyManager" */ '@/views/SecurityManager/SecurityManagerPrivilege.vue'),
            props: true,
            meta: { permission: 'SYS:SEC:ROLEMGR:VIEW', title: 'Security Manager: Role Profile - Privileges' },
          },
        ],
      },
      {
        path: 'nearMatches',
        name: 'pidNearMatches',
        component: () => import(/* webpackChunkName: "nearMatchList" */ '@/views/PersonId/NearMatches/NearMatchList.vue'),
        props: (route) => {
          const {
            pidBatchId,
            pidSubmissionId,
            endDate,
            identifier,
            page,
            startDate,
            districtCode = [],
            identifierType = [],
            matchType = [],
            programCode = [],
            schoolCode = [],
            schoolYear = [],
            sortField,
            sortOrder,
          } = route.query;

          return {
            pidBatchId,
            pidSubmissionId,
            endDate,
            identifier,
            page: Number(page),
            startDate,
            districtCode: ensureArray(districtCode),
            identifierType: ensureArray(identifierType),
            matchType: ensureArray(matchType),
            programCode: ensureArray(programCode),
            schoolCode: ensureArray(schoolCode),
            schoolYear: ensureArray(schoolYear),
            sortField,
            sortOrder,
          };
        },
        beforeEnter(to, from, next) {
          const route = Object.assign({}, to);
          if (!route.query.pidSubmissionId
            && !route.query.pidBatchId
            && !route.query.startDate) {
            if (!route.query.schoolYear) {
              route.query.schoolYear = store.state.propertiesModule.properties['RULE-CURRENT_SCHOOL_YEAR'];
            }
            next(route);
          }
          next();
        },
        meta: { permission: 'PRSID:MATCH:RESOLVENM:VIEW', title: 'Person ID: Near Match List' },
      },
      {
        path: 'compare/:nearMatchId',
        name: 'pidCompareMatches',
        component: () => import(/* webpackChunkName: "matchoptions" */ '@/views/PersonId/NearMatches/CompareMatches.vue'),
        props: true,
        meta: { permission: 'PRSID:MATCH:RESOLVENM:VIEW', title: 'Person ID: Near Match Compare' },
      },
    ],
  },
];
